import PropTypes from 'prop-types';
import React from 'react';
import {
 ButtonToolbar,
 Button,
} from 'react-bootstrap';

import { tourType } from './CatchPropTypes';
import TourBadge from './TourBadge';
import TourListToolbar from './TourListToolbar';
import TourEditModal from './TourEditModal';

class TourList extends React.Component {
  constructor() {
    super();
    this.state = {
      show: false,
    };

    this.handleAddTour = this.handleAddTour.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  handleAddTour() {
    this.setState({ show: true });
  }

  handleClose() {
    this.setState({ show: false });
  }

  render() {
    
    const auth = JSON.parse(sessionStorage.getItem('auth'));
    const newTour = {
      manager : auth.profile.user.id.toString()
    };
    const tours = [];
    this.props.tours.forEach((tour) => {
      if (!this.props.filter[tour.state]) {
        tours.push(<TourBadge tour={tour} key={tour.id} />);
      }
    });
    return (
      <div className="container-fluid">
        <div className="row tour-head">
          <div className="col-xs-6 col-sm-6 col-md-6 tour-headText">
            <h2>Travel</h2>
          </div>
          <div className="col-xs-6 col-sm-6 col-md-6 tour-headBar">
            <ButtonToolbar className="tour-headBtn">
              <TourListToolbar
                filter={this.props.filter}
                tourFilterSet={this.props.tourFilterSet}
                isTourManager={this.props.isTourManager}
                handleAddTour={this.handleAddTour}
              />
            </ButtonToolbar>
          </div>
        </div>
        <hr />
        <div className="row">
          {tours}
          { !this.props.isTourManager &&
          (
          <div className="col-sm-6 tour-container">
            <div className="add-tour">
              <Button onClick={this.handleAddTour} bsStyle="success">
                + Add Travel
              </Button>
              <TourEditModal
                tour={newTour}
                show={this.state.show}
                onClose={this.handleClose}
                addTour={this.props.addTour}
                editTour={this.props.editTour}
                requestTourManagers={this.props.requestTourManagers}
                tourManagers = {this.props.tourManagers}
              />
            </div>
          </div>
        )}
        </div>
      </div>
    );
  }
}
TourList.propTypes = {
  tours: PropTypes.arrayOf(PropTypes.shape(tourType)).isRequired,
  filter: PropTypes.object.isRequired,
  addTour: PropTypes.func.isRequired,
  editTour: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  tourFilterSet: PropTypes.func.isRequired,
};
export default TourList;



// WEBPACK FOOTER //
// src/routes/tours/components/TourList.js